import { render, staticRenderFns } from "./TransitionExpand.vue?vue&type=template&id=09b2dd8c&scoped=true"
import script from "./TransitionExpand.vue?vue&type=script&lang=js"
export * from "./TransitionExpand.vue?vue&type=script&lang=js"
import style0 from "./TransitionExpand.vue?vue&type=style&index=0&id=09b2dd8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b2dd8c",
  null
  
)

export default component.exports